import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Input, TextArea, useLocalizeMessage, FormSections } from 'libs.nucleus';
export const AddEditMeasureStep1 = ({ formData, onFormChange, isEditMode = false }) => {
    const translate = useLocalizeMessage();
    const [name, setName] = useState(formData.name || '');
    const [description, setDescription] = useState(formData.description || '');
    useEffect(() => {
        setName(formData.name || '');
        setDescription(formData.description || '');
    }, [formData.name, formData.description]);
    const handleNameChange = (value) => {
        setName(value);
        onFormChange({ ...formData, name: value });
    };
    const handleDescriptionChange = (value) => {
        setDescription(value);
        onFormChange({ ...formData, description: value });
    };
    const formSections = [
        {
            title: translate('Details'),
            content: (_jsxs("div", { className: 'flex flex-col gap-6 max-w-input-lg', children: [_jsx(Input, { id: 'name', label: translate('Name'), value: name, onChange: (e) => handleNameChange(e.target.value), required: true, width: 'full', autoComplete: 'off', disabled: isEditMode }), _jsx(TextArea, { id: 'description', label: translate('Description'), value: description, onChange: (e) => handleDescriptionChange(e.target.value), width: 'full' })] })),
        },
    ];
    return (_jsx("div", { className: 'flex flex-col size-full', children: _jsx(FormSections, { sections: formSections }) }));
};
